var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Message",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.486,
    height: 63.569,
    viewBox: "0 0 79.486 63.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M288.464,169.979v13.711a19.9,19.9,0,0,1-16.732,19.633,26.981,26.981,0,0,0-11.645,4.849l-4.332,3.179a11.865,11.865,0,0,1-14.109,0l-4.292-3.179a27.184,27.184,0,0,0-11.645-4.849,19.862,19.862,0,0,1-16.732-19.633V169.979a19.879,19.879,0,0,1,19.871-19.871h39.743A19.879,19.879,0,0,1,288.464,169.979Z",
    transform: "translate(-208.978 -150.108)",
    fill: "#0e71f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M230.4,158.127a1.621,1.621,0,0,1-1.61,1.61H217.116a1.61,1.61,0,0,1,0-3.219H228.79a1.607,1.607,0,0,1,1.61,1.61Z",
    transform: "translate(-183.218 -129.675)",
    fill: "#030835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117550",
    "data-name": "Path 117550",
    d: "M230.4,158.127a1.621,1.621,0,0,1-1.61,1.61H217.116a1.61,1.61,0,0,1,0-3.219H228.79a1.607,1.607,0,0,1,1.61,1.61Z",
    transform: "translate(-183.218 -121.675)",
    fill: "#030835"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117549",
    "data-name": "Path 117549",
    d: "M230.4,158.127a1.621,1.621,0,0,1-1.61,1.61H217.116a1.61,1.61,0,0,1,0-3.219H228.79a1.607,1.607,0,0,1,1.61,1.61Z",
    transform: "translate(-183.218 -137.675)",
    fill: "#030835"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.09cae300df30c3eac3189a47dd907420.svg";
export { ForwardRef as ReactComponent };